/// <reference path="../../jquery.d.ts" />

module PoskiQ {
    "use strict";

    export class ConfProductPrekryv {
        public static Instance: ConfProductPrekryv;
        private zaklad: string;
        private $nahled: JQuery;
        private $prekryvy: JQuery;

        public constructor() {
            this.$nahled = $('.js-prekryv');
            this.zaklad = this.$nahled.find('img').attr('src');
            this.$prekryvy = $('[data-prekryv]');

            this.bindEvents();
            this.render();
        }

        private bindEvents() {
            this.$prekryvy.on('change', () => { this.render(); });
        }

        private render() {
            this.$nahled.empty();
            this.$nahled.append($('<img/>').attr('src', this.zaklad));
            this.$prekryvy.filter(':checked, :selected').each((_, el) => {
                let prekryv : string = $(el).attr('data-prekryv');
                if (prekryv) {
                    this.$nahled.append($('<img/>').attr('src', prekryv));
                }
            });
        }
    }

    $(function () {
        if ($('.js-prekryv').length == 0)
            return;

        PoskiQ.ConfProductPrekryv.Instance = new ConfProductPrekryv();
    });
}
